import React, { useContext } from "react";
import {  Spin, } from "antd";
import {
  LoadingOutlined,
} from "@ant-design/icons";
import useExpertDashboard from "PlatForms/Dashboards/ExpertDashboard/Hooks/useExpertDashboard";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import ProfileIncompleteAlert from "Common/Components/ProfileIncompleteAlert";
import { ExpertHeader } from "./ExpertHeader";
import SkillstAlert from "../Skills/SkillsAlert";

const ExpertLandingPage = () => {
  const { isProfileComplete, loading: profileLoading } = useContext(ProfileContext);
  const { dashboardData, skills,loading, error } = useExpertDashboard();
  console.log("skills in landing",skills)

  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#1890ff" }} spin />;

  if (loading || profileLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <Spin indicator={spinnerIcon} tip="Loading..." />
      </div>
    );
  }

  if (error || !dashboardData) {
    return <div style={{ padding: 20 }}>{error ? `⚠️ Error: ${error}` : "No data available"}</div>;
  }

  return (
    <div style={{ padding: "12px 24px" }}>
      {/* Passing learner data to Header for Image and Greeting */}
          <ExpertHeader 
      userName={`${dashboardData.expert.firstName} ${dashboardData.expert.lastName}`}
        expertCode={dashboardData.expert.expertCode} 

    />


      <div>
        {!isProfileComplete && <ProfileIncompleteAlert navigateTo="/expert-profile" />}
        
        <SkillstAlert skills={skills || []} />
       




     


      </div>
    </div>
  );
};

export default ExpertLandingPage;